// extracted by mini-css-extract-plugin
export var header = "_xd-1";
export var maskBottom = "_xd-6";
export var maskMiddle = "_xd-7";
export var maskTop = "_xd-5";
export var root = "_xd-0";
export var scrollDownButton = "_xd-3";
export var scrollDownButtonHidden = "_xd-4";
export var viewport = "_xd-2";